import { render, staticRenderFns } from "./BackgroundColorEditor.vue?vue&type=template&id=52097fbe&scoped=true"
import script from "./BackgroundColorEditor.vue?vue&type=script&lang=js"
export * from "./BackgroundColorEditor.vue?vue&type=script&lang=js"
import style0 from "./BackgroundColorEditor.vue?vue&type=style&index=0&id=52097fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52097fbe",
  null
  
)

export default component.exports